import { irm_templateInfo } from 'owa-locstrings/lib/strings/irm_templateinfo.locstring.json';
import {
    warningUpgradeMessage,
    warningFailedToShowOriginalMessage,
    errorMessageInvalidSenderMailCanNotBeSend,
    warningMessageMaxRecipientsExceed,
    errorMessageNoPermissionToSendAs,
    errorMessageSubmissionQuotaExceededMessageCanNotBeSent,
    errorMessageItemNoLongerExistToSend,
    errorMessageItemNoLongerExistToSave,
    warningMessageNoPermissionToPerformAction,
    errorMessageQuotaExceededMessageCanNotBeSent,
    errorMessageQuotaExceededMessageCanNotBeSaved,
    errorMessageMessageCanNotBeSaved,
    error500,
    error503,
    errorFailedToFetch,
    errorSessionTimeout,
    errorMailboxStoreUnavailable,
    errorMessageAccountSuspend,
    errorMessageExceededMaxRecipientLimitPremium,
    errorMessageExceededMaxRecipientLimit,
    errorMessageExceededMessageLimitPremium,
    errorMessageExceededMessageLimit,
    errorMessageExceededHourlyMessageLimit,
    errorMessageMessageBlocked,
    errorMessageMessageSubmissionBlocked,
    errorMessageAccountSuspendShowTierUpgrade,
    errorMessageExceededMaxRecipientLimitShowTierUpgrade,
    errorMessageExceededMessageLimitShowTierUpgrade,
    errorMessageTransientError,
    cmpEncryptMessage,
    cmpEncryptMessageDNF,
    cmpEncryptionDlpPolicyTips,
    policyTipsPrefix,
    policyTipsUndoLink,
    cmpEncryptionTips,
    cmpDlpConfirmEncryption,
    UnableToSaveMessage,
    smimeComposeHasIRM,
    dictationSilenceBusinessBarMessage,
    messageClassificationInfoBarMessage,
    clpLabelInfoBarMessage,
    clpAutoLabelAutomaticInfoBarMessage,
    clpAutoLabelRecommendedInfoBarMessage,
    proofingDiableDueToMessageSizeInfoBarMessage,
} from './getInfoBarMessageViewState.locstring.json';
import { errorMessageMessageCanNotBeSent } from 'owa-mail-compose-actions/lib/strings.locstring.json';
import { errorMessageNoRecipentsMailCanNotBeSend } from 'owa-locstrings/lib/strings/errormessagenorecipentsmailcannotbesend.locstring.json';
import loc, { format } from 'owa-localize';
import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';
import getInfoBarMessageCreator from 'owa-info-bar/lib/utils/infoBarMessageCreatorsMap';
import {
    getInfoBarViewState,
    AttachmentPolicyInfoBarId,
} from 'owa-attachment-policy-access-issue-checker';
import protectMessageAndRemoveAddin from 'owa-mail-compose-actions/lib/utils/protectMessageAndRemoveAddin';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import getRemoveProtectionInfobarMessage from 'owa-mail-protection/lib/utils/rms/getRemoveProtectionInfobarMessage';
import getRemoveClassificationLink from 'owa-mail-protection/lib/utils/classification/getRemoveClassificationLink';
import {
    getChangeLabelLink,
    getClearInfobarIcon,
} from 'owa-mail-protection/lib/utils/clp/getChangeLabelLink';
import removeRecipientsFromRecipientWells from 'owa-readwrite-recipient-well/lib/actions/removeRecipientsFromRecipientWells';
import setIsFalsePositive from 'owa-policy-tips/lib/actions/setIsFalsePositive';
import setOverrideJustification from 'owa-policy-tips/lib/actions/setOverrideJustification';
import shouldDisableEncryptionButton from 'owa-mail-protection/lib/utils/rms/shouldDisableEncryptionButton';
import createModifyProtectionInfoBarCustomAction from './createModifyProtectionInfoBarCustomAction';
import { ENCRYPT_GUID } from 'owa-mail-protection/lib/store/schema/rms/EncryptionGUID';

import { getPolicyTipsCustomAction } from 'owa-policy-tips/lib/utils/getPolicyTipsCustomAction';
import { getPolicyTipsInfoBarMessage } from 'owa-policy-tips/lib/utils/getPolicyTipsInfoBarMessage';
import { getSensitivityInfoBarMessage } from 'owa-mail-sensitivity';
import { getUserConfiguration } from 'owa-session-store';
import {
    getAllRecipients,
    getRecipientWellsFromComposeViewState,
} from 'owa-mail-compose-actions/lib/utils/getAllRecipientsAsEmailAddressStrings';
import {
    InfoBarMessageSource,
    InfoBarMessageRank,
    InfoBarMessageViewState,
    InfoBarCustomAction,
    MessagePart,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import {
    getUpgradeToPremiumButton,
    getHipVerifyButton,
    getAccountRecoveryFlowButton,
} from 'owa-mail-compose-actions/lib/utils/wasclUtils';
import getSmimeEncodeErrorInfoBarMessage from 'owa-smime/lib/utils/getSmimeEncodeErrorInfoBarMessage';
import getSmimeControlErrorInfobarMessage from 'owa-smime/lib/utils/getSmimeControlErrorInfobarMessage';
import SmimeContext from 'owa-smime/lib/store/schema/SmimeContext';
import isCLPEnabled from 'owa-mail-protection/lib/utils/clp/isCLPEnabled';
import { LabelApplyMethod } from 'owa-mail-protection/lib/store/schema/clp/CLPViewState';

const ENCRYPT_LEARN_MORE = 'https://go.microsoft.com/fwlink/?linkid=867644';

function createInfoBarViewState(
    messageId: string,
    messages: MessagePart[],
    rank: InfoBarMessageRank = InfoBarMessageRank.Error
): InfoBarMessageViewState {
    return {
        key: messageId,
        source: InfoBarMessageSource.Compose,
        rank: rank,
        message: messages.filter(message => typeof message === 'string').join(' '),
        messageParts: messages,
    };
}

export default function getInfoBarMessageViewState(
    messageId: string,
    composeViewState: ComposeViewState,
    targetWindow: Window
): InfoBarMessageViewState {
    let messages: MessagePart[] = [];
    let rank: InfoBarMessageRank;
    const { protectionViewState } = composeViewState;
    const { clpViewState, IRMData } = protectionViewState;
    const { autoLabelViewState } = clpViewState;
    const isPremiumConsumerMailbox = getUserConfiguration().SessionSettings
        .IsPremiumConsumerMailbox;
    const infoBarMessageViewCreator = getInfoBarMessageCreator(composeViewState, messageId);
    if (infoBarMessageViewCreator) {
        if (typeof infoBarMessageViewCreator === 'function') {
            return infoBarMessageViewCreator(composeViewState);
        } else {
            messages = infoBarMessageViewCreator;
        }
    } else {
        switch (messageId) {
            // UpConvert / Upgrade
            case 'warningNoQuotedBody':
                messages = [loc(warningUpgradeMessage)];
                break;
            case 'warningFailureToShowOriginalMessage':
                messages = [loc(warningFailedToShowOriginalMessage)];
                break;

            // Client send validation
            case 'errorMessageNoRecipentsMailCanNotBeSend':
                messages = [loc(errorMessageNoRecipentsMailCanNotBeSend)];
                break;
            case 'errorMessageInvalidSenderMailCanNotBeSend':
                messages = [loc(errorMessageInvalidSenderMailCanNotBeSend)];
                break;
            case 'warningMessageMaxRecipientsExceed':
                messages = [loc(warningMessageMaxRecipientsExceed)];
                break;
            case 'errorMessageFileCanNotBeSaved':
                messages = [loc(UnableToSaveMessage)];
                break;

            // Server side error message
            case 'errorMessageNoPermissionToSendAs':
                messages = [loc(errorMessageNoPermissionToSendAs)];
                break;
            case 'errorMessageSubmissionQuotaExceededMessageCanNotBeSent':
                messages = [loc(errorMessageSubmissionQuotaExceededMessageCanNotBeSent)];
                break;

            case 'errorMessageItemNoLongerExistToSend':
                messages = [loc(errorMessageItemNoLongerExistToSend)];
                break;
            case 'errorMessageItemNoLongerExistToSave':
                messages = [loc(errorMessageItemNoLongerExistToSave)];
                break;
            case 'warningMessageNoPermissionToPerformAction':
                messages = [loc(warningMessageNoPermissionToPerformAction)];
                break;
            case 'errorMessageQuotaExceededMessageCanNotBeSent':
                messages = [loc(errorMessageQuotaExceededMessageCanNotBeSent)];
                break;
            case 'errorMessageQuotaExceededMessageCanNotBeSaved':
                messages = [loc(errorMessageQuotaExceededMessageCanNotBeSaved)];
                break;
            case 'errorMessageMessageCanNotBeSent':
                messages = [loc(errorMessageMessageCanNotBeSent)];
                break;
            case 'errorMessageMessageCanNotBeSaved':
                messages = [loc(errorMessageMessageCanNotBeSaved)];
                break;
            case 'error500':
                messages = [loc(error500)];
                break;
            case 'error503':
                messages = [loc(error503)];
                break;
            case 'errorFailedToFetch':
                messages = [loc(errorFailedToFetch)];
                break;
            case 'errorSessionTimeout':
                messages = [loc(errorSessionTimeout)];
                break;
            case 'errorMailboxStoreUnavailable':
                messages = [loc(errorMailboxStoreUnavailable)];
                break;

            // Wascl related error message
            case 'errorMessageAccountSuspend':
                messages = [
                    loc(errorMessageAccountSuspend),
                    getAccountRecoveryFlowButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMaxRecipientLimit':
                if (isPremiumConsumerMailbox) {
                    messages = [loc(errorMessageExceededMaxRecipientLimitPremium)];
                } else {
                    messages = [
                        loc(errorMessageExceededMaxRecipientLimit),
                        getUpgradeToPremiumButton(composeViewState),
                    ];
                }
                break;
            case 'errorMessageExceededMessageLimit':
                if (isPremiumConsumerMailbox) {
                    messages = [loc(errorMessageExceededMessageLimitPremium)];
                } else {
                    messages = [
                        loc(errorMessageExceededMessageLimit),
                        getUpgradeToPremiumButton(composeViewState),
                    ];
                }
                break;
            case 'errorMessageExceededHourlyMessageLimit':
                messages = [loc(errorMessageExceededHourlyMessageLimit)];
                break;
            case 'errorMessageMessageBlocked':
                messages = [loc(errorMessageMessageBlocked)];
                break;
            case 'errorMessageMessageSubmissionBlocked':
                messages = [
                    loc(errorMessageMessageSubmissionBlocked),
                    getHipVerifyButton(composeViewState, targetWindow),
                ];
                break;
            case 'errorMessageAccountSuspendShowTierUpgrade':
                messages = [
                    loc(errorMessageAccountSuspendShowTierUpgrade),
                    getAccountRecoveryFlowButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMaxRecipientLimitShowTierUpgrade':
                messages = [
                    loc(errorMessageExceededMaxRecipientLimitShowTierUpgrade),
                    getHipVerifyButton(composeViewState, targetWindow),
                ];
                break;
            case 'errorMessageExceededMessageLimitShowTierUpgrade':
                messages = [
                    loc(errorMessageExceededMessageLimitShowTierUpgrade),
                    getHipVerifyButton(composeViewState, targetWindow),
                ];
                break;

            case 'errorMessageTimeout':
                messages = [format(loc(errorMessageTransientError), '(0x00000002)')];
                break;

            case 'errorMessageThrottled':
                messages = [format(loc(errorMessageTransientError), '(0x00000008)')];
                break;

            case 'errorMessageTransientError':
                messages = [format(loc(errorMessageTransientError), '(0x00004000)')];
                break;

            // IRM protection
            case 'encryption':
                messages = [loc(cmpEncryptMessage)];
                if (IRMData.IsOwner) {
                    messages.push(
                        getRemoveProtectionInfobarMessage(
                            composeViewState,
                            protectionViewState,
                            'encryption'
                        )
                    );
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;

            case 'encryptionDoNotForward':
                messages = [loc(cmpEncryptMessageDNF)];
                if (IRMData.IsOwner) {
                    messages.push(
                        getRemoveProtectionInfobarMessage(
                            composeViewState,
                            protectionViewState,
                            'encryptionDoNotForward'
                        )
                    );
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;

            case 'consumerDlpPolicyTips':
                messages = [loc(cmpEncryptionDlpPolicyTips)];
                // If compliance configuration is not ready, do not show the confirm encryption link
                if (!shouldDisableEncryptionButton(protectionViewState, ENCRYPT_GUID)) {
                    messages.push(confirmEncryptMessage(composeViewState));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;

            case 'enterpriseDlpPolicyTips':
                const recipientWells = getRecipientWellsFromComposeViewState(composeViewState);
                const policyTipsViewState = composeViewState.policyTipsViewState;
                const infoBarMessage = getPolicyTipsInfoBarMessage(policyTipsViewState);
                messages = [loc(policyTipsPrefix), infoBarMessage];
                if (
                    policyTipsViewState.isReportedFalsePositive ||
                    policyTipsViewState.isOverridden
                ) {
                    messages.push({
                        text: loc(policyTipsUndoLink),
                        action: () => {
                            setIsFalsePositive(composeViewState.policyTipsViewState, false);
                            // Setting to null here is required, as an empty string is a valid justification for silent override.
                            setOverrideJustification(composeViewState.policyTipsViewState, null);
                        },
                    });
                    messages.push('|');
                }
                const customPart = getPolicyTipsCustomAction(
                    composeViewState.policyTipsViewState,
                    getAllRecipients(composeViewState),
                    recipients => removeRecipientsFromRecipientWells(recipients, recipientWells)
                );
                if (customPart) {
                    messages.push(customPart);
                }

                rank = InfoBarMessageRank.Encryption;
                break;

            case 'infoSensitivity':
                messages = getSensitivityInfoBarMessage(composeViewState.sensitivity);
                break;

            case 'irmInfoBar':
                if (IRMData) {
                    const fullText = format(
                        loc(irm_templateInfo),
                        IRMData.TemplateName,
                        IRMData.TemplateDescription
                    );
                    messages = [fullText];
                    if (IRMData.IsOwner) {
                        if (!isCLPEnabled()) {
                            messages.push(
                                createModifyProtectionInfoBarCustomAction(
                                    composeViewState,
                                    targetWindow
                                )
                            );
                            messages.push('|');
                        }
                        messages.push(
                            getRemoveProtectionInfobarMessage(
                                composeViewState,
                                protectionViewState,
                                'irmInfoBar'
                            )
                        );
                    }
                    rank = InfoBarMessageRank.Encryption;
                }
                break;
            case AttachmentPolicyInfoBarId.ReadOnlyAccess:
            case AttachmentPolicyInfoBarId.ReadOnlyPlusAttachmentsBlockedAccess:
                return getInfoBarViewState(messageId);
            case 'errorSmimeComposeHasIRM':
                messages = [loc(smimeComposeHasIRM)];
                rank = InfoBarMessageRank.Error;
                break;
            case 'smimeEncodeError':
                const { errorCode, errorContext } = composeViewState.smimeViewState;
                return getSmimeEncodeErrorInfoBarMessage(
                    'smimeEncodeError',
                    errorCode,
                    errorContext
                );
            case 'smimeAdapterInitializationError':
                const isReplyOrReplyAll =
                    composeViewState.operation == ComposeOperation.Reply ||
                    composeViewState.operation == ComposeOperation.ReplyAll;
                const isForward = composeViewState.operation == ComposeOperation.Forward;
                return getSmimeControlErrorInfobarMessage(
                    'smimeAdapterInitializationError',
                    SmimeContext.EncodingMessage,
                    false /* isItemSigned */,
                    true /* isCompose */,
                    isReplyOrReplyAll,
                    isForward
                );
            case 'CLPLabel':
                const { selectedCLPLabel } = clpViewState;
                if (selectedCLPLabel) {
                    messages = [
                        format(loc(clpLabelInfoBarMessage), selectedCLPLabel.infobarDisplayText),
                    ];
                    if (selectedCLPLabel.isEncryptingLabel) {
                        rank = InfoBarMessageRank.Encryption;
                    } else {
                        rank = InfoBarMessageRank.Sensitivity;
                    }
                }
                break;
            case 'CLPAutoLabelAutomatic':
                if (clpViewState.labelApplyMethod == LabelApplyMethod.Automatic) {
                    messages = [
                        format(
                            loc(clpAutoLabelAutomaticInfoBarMessage),
                            clpViewState.selectedCLPLabel.infobarDisplayText
                        ),
                    ];
                    rank = InfoBarMessageRank.Info;
                }
                break;
            case 'CLPAutoLabelRecommended':
                const { recommended } = autoLabelViewState;
                if (recommended) {
                    messages = [
                        format(
                            loc(clpAutoLabelRecommendedInfoBarMessage),
                            recommended.infobarDisplayText
                        ),
                        getChangeLabelLink(composeViewState, clpViewState, recommended),
                        ' | ',
                        getClearInfobarIcon(composeViewState),
                    ];
                    rank = InfoBarMessageRank.Info;
                }
                break;
            case 'dictationSilenceBusinessBarMessage':
                messages = [loc(dictationSilenceBusinessBarMessage)];
                break;
            case 'messageClassification':
                const { classificationViewState } = protectionViewState;
                const { messageClassification } = classificationViewState;
                const { RmsV2UIEnabled } = getUserConfiguration();
                if (messageClassification) {
                    messages = [
                        format(
                            loc(messageClassificationInfoBarMessage),
                            messageClassification.Name,
                            messageClassification.Description
                        ),
                    ];
                    // When classification is not display in the setPermission dropdown,
                    // show links to change permission and remove classification
                    if (RmsV2UIEnabled) {
                        messages.push(
                            createModifyProtectionInfoBarCustomAction(
                                composeViewState,
                                targetWindow
                            )
                        );
                        messages.push('|');
                        messages.push(
                            getRemoveClassificationLink(classificationViewState, composeViewState)
                        );
                    }
                    rank = InfoBarMessageRank.Info;
                }
                break;
            case 'proofingDiabledDueToSize':
                messages = [loc(proofingDiableDueToMessageSizeInfoBarMessage)];
                rank = InfoBarMessageRank.Info;
                break;
            default:
                break;
        }
    }

    return createInfoBarViewState(messageId, messages, rank);
}

function getEncryptionTips(): InfoBarCustomAction {
    return {
        text: loc(cmpEncryptionTips),
        action: () => {
            window.open(ENCRYPT_LEARN_MORE, '_blank');
        },
    };
}

function confirmEncryptMessage(composeViewState: ComposeViewState): InfoBarCustomAction {
    return {
        text: loc(cmpDlpConfirmEncryption),
        action: () => {
            removeInfoBarMessage(composeViewState, 'consumerDlpPolicyTips');
            protectMessageAndRemoveAddin(composeViewState, ENCRYPT_GUID);
        },
    };
}
